import { Injectable } from '@angular/core';
import { Query } from '../models/query.model';
import {Params} from '@angular/router';

@Injectable()
export class ConvertQueryParamsService {

    /**
     * Convert Query to Params
     */
    public queryToParams(query: Query): Params {
        // Initialize query params
        const params = {
            key: query.keyword || null,
            cat: query.selectedCategory || null,
            type: query.type ? query.type.toLowerCase() : null,
            page: query.page || 1
        };

        // Loop through all filters and add to params if checked
        if (query.filters !== undefined) {
            for (const filterName of Object.keys(query.filters)) {
                const checkedFilterValues = query.filters[filterName].filter(filter => filter.checked).map(filter => filter.value).join(',');
                if (checkedFilterValues) {
                    params['f-' + filterName] = checkedFilterValues;
                }
            }
        }

        return params;
    }

    /**
     * Convert Query params to Query
     */
    public paramsToQuery(params: Params): Query {
        const filters = {};
        for (const param of Object.keys(params)) {
            // Filters start with 'f-'
            if (param.startsWith('f-')) {
                // Multiple filters are comma separated
                filters[param.substring(2)] = params[param].split(',').map(value => {
                    return {checked: true, value};
                });
            }
        }

        return {
            filters,
            keyword: params.key || null,
            selectedCategory: params.cat || null,
            type: params.type ? params.type.toLowerCase() : null,
            page: params.page || 1
        };
    }
}
